import { useCallback, useState } from "react";
import { otherDeductionStagingService } from "../services/otherAdditionStagingService";

export const useOtherAdditionStaging = ({
	setIsUpload,
	isGenerate,
	filterPayTypeId,
	filterPayrollPeriodId,
	filterClassificationId,
}) => {


	const [otherAdditionData, setOtherAdditionData] = useState([]);
	const [filterDataAddition, setFilterDataAddition] = useState([]);
	const [loadingOtherAddition, setLoadingOtherAddition] = useState(false);

	const fetchAdditionData = useCallback(async () => {
		if (!isGenerate) return;

		if (!filterPayTypeId || !filterPayrollPeriodId || !filterClassificationId) return;

		const pathSegments = [
			`paytype/${filterPayTypeId}`,
			`payrollperiod/${filterPayrollPeriodId}`,
			`classification/${filterClassificationId}`,
			`location/0/section/0`
		]
		const processDataParam = pathSegments.join("/");

		try {
			setLoadingOtherAddition(true);
			const response = await otherDeductionStagingService.getPayrollOtherAdditions(processDataParam);
			setOtherAdditionData(response.data);
			setFilterDataAddition(response.data);
			setIsUpload(false);
		} catch (error) {
			console.error("Error fetching data:", error);
		} finally {
			setLoadingOtherAddition(false);
		}
	}, [
		setIsUpload,
		isGenerate,
		filterPayTypeId,
		filterPayrollPeriodId,
		filterClassificationId,
		setOtherAdditionData,
	]);

	return {
		loadingOtherAddition,
		otherAdditionData, setOtherAdditionData,
		filterDataAddition, setFilterDataAddition,
		fetchAdditionData
	}
}